import { throwErrorMessage, throwSuccessMessage } from "../../lib/error_helper";
import { fetchWithTimeout } from "../../lib/fetch_wrapper";
import { distinct } from "../../utils";
import {
    formsIsLoading,
    getFiltersInstance,
    getFormsAndInterviewsToManage,
    getInterviewsForHR,
    getMyFormsAndInterviews,
    isVisible,
    sectionRead,
    setCurrentInterviewAction,
    setCurrentSectionAction,
    setFormFiltersAction,
    setFormSectionsAction,
} from "./humanResourcesActions";
import { adaptResponseForMyOpen } from "./humanResourcesCast";

export function validateInterview(form, sections, interview, user, history) {
    return (dispatch) => {
        let formOk = dispatch(checkFormIntegrity(sections));

        if (!formOk) return;

        if (!window.confirm("Attention, la validation rendra les données non modifiables. Voulez-vous continuer ?"))
            return;

        const headers = new Headers({ "Content-Type": "application/json" });
        let questions = [];
        sections.forEach((s) => (questions = questions.concat(s.questions)));
        dispatch(formsIsLoading(true));

        fetchWithTimeout("/api/v1/human_resources/save_form", {
            method: "POST",
            headers: headers,
            body: JSON.stringify({
                userId: user.id,
                form,
                questions,
                validate: true,
                interviewId: interview.id,
            }),
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then(() => {
                dispatch(formsIsLoading(false));
                interview.state = "done";
                dispatch(setCurrentInterviewAction(interview));

                dispatch(
                    throwSuccessMessage({
                        title: "L'entretien a bien été validé",
                    })
                );
                history.push("/humanResources");
            })
            .catch((err) => {
                console.error("Erreur : humanResourcesEditionActions - validateInterview", err);

                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la validation du formulaire !",
                    })
                );

                dispatch(formsIsLoading(false));
            });
    };
}

export function checkFormIntegrity(sections) {
    return (dispatch) => {
        let formOk = true;
        let allQuestionsOk = true;
        let multipleChoiceQuestionsOk = true;

        sections
            .sort((s) => s.sequence)
            .forEach((s) => {
                if (!sectionRead(s)) {
                    dispatch(
                        throwErrorMessage({
                            uid: s.id,
                            title: "La section " + s.title + " n'a pas été visualisée",
                        })
                    );

                    formOk = false;
                }

                if (formOk)
                    s.questions
                        .sort((q) => q.sequence)
                        .forEach((question) => {
                            if (!allQuestionsOk)
                                //On ne vérifie pas les autres sections si une section n'est pas correctement remplie pour éviter les traitements inutiles et le flood de message
                                return;

                            let response = question.response_lines[0];
                            let responseAnswers = response.response_answers.filter((ra) => !ra.deleted);

                            if (
                                (!question.is_require_answer && response.state !== "draft") ||
                                question.type === "descriptive_text" ||
                                !isVisible(sections, question)
                            )
                                return;

                            if (question.is_conditional) {
                                let conditionalQuestion;

                                sections.forEach((section) => {
                                    if (!conditionalQuestion)
                                        conditionalQuestion = section.questions.find(
                                            (q) => q.id === question.triggering_question_id
                                        );
                                });

                                if (!conditionalQuestion || conditionalQuestion.response_lines.length <= 0) return;

                                let currentResponses = conditionalQuestion.response_lines[0].response_answers;

                                if (
                                    !currentResponses.find(
                                        (ra) => !ra.deleted && ra.answer_id === question.triggering_answer_id
                                    )
                                )
                                    return;
                            }

                            let questionOk = true;
                            let leastQuestionOk = true;
                            let mustQuestionOk = true;
                            let exactQuestionOk = true;

                            if (
                                question.type === "matrix_of_choices_only_multi_ans" ||
                                question.type === "matrix_of_choices_only_one_ans"
                            ) {
                                let rowsIdsAnswered = responseAnswers
                                    .filter((ra) => ra.value_choice)
                                    .map((ra) => ra.answer_id)
                                    .filter(distinct);
                                questionOk =
                                    rowsIdsAnswered.length === question.answer_choice_ids.length ? true : false;
                            } else if (question.type === "table") {
                                questionOk = true; //Un tableau ne peut-être requis
                            } else if (question.type === "rating_scale") {
                                let rowsIdsAnswered = responseAnswers
                                    .filter((ra) => ra.column_id)
                                    .map((ra) => ra.answer_id)
                                    .filter(distinct);
                                questionOk =
                                    rowsIdsAnswered.length === question.answer_choice_ids.length ? true : false;
                            } else if (question.type === "date" || question.type === "date_and_time") {
                                questionOk = responseAnswers.length > 0 && responseAnswers[0].answer ? true : false;
                            } else if (question.type === "single_textbox" || question.type === "numerical_textboxes") {
                                questionOk = response.single_text ? true : false;
                            } else if (
                                question.type === "comment" ||
                                question.type === "multiple_textboxes" ||
                                question.type === "multiple_textboxes_diff_type"
                            ) {
                                questionOk = response.comment ? true : false;
                            } else if (
                                question.type === "multiple_choice_only_one_ans" ||
                                question.type === "multiple_choice_multiple_ans"
                            ) {
                                questionOk = responseAnswers.length > 0 && responseAnswers[0].answer_id ? true : false;
                                if (question.req_ans) {
                                    if (
                                        question.required_type === "at least" &&
                                        responseAnswers.length < question.req_ans
                                    ) {
                                        leastQuestionOk = false;
                                    } else if (
                                        question.required_type === "at most" &&
                                        responseAnswers.length > question.req_ans
                                    ) {
                                        mustQuestionOk = false;
                                    } else if (
                                        question.required_type === "exactly" &&
                                        responseAnswers.length !== question.req_ans
                                    ) {
                                        exactQuestionOk = false;
                                    }
                                }
                            } else {
                                questionOk = false;
                            }

                            if (response.state === "draft") questionOk = false;

                            if (!questionOk) {
                                dispatch(
                                    throwErrorMessage({
                                        title: "Le formulaire n'est pas rempli",
                                        message:
                                            "Veuillez répondre à la question [" +
                                            question.question +
                                            "] de la section [" +
                                            s.title +
                                            "]",
                                    })
                                );

                                allQuestionsOk = false;
                            } else {
                                if (!leastQuestionOk) {
                                    dispatch(
                                        throwErrorMessage({
                                            title: "Réponse incompléte",
                                            message:
                                                "La question [" +
                                                question.question +
                                                "] de la section [" +
                                                s.title +
                                                "] doit présenter au minimum " +
                                                question.req_ans +
                                                " choix.",
                                            dismissAfter: 20000,
                                        })
                                    );

                            multipleChoiceQuestionsOk = false;
                        } else if (!mustQuestionOk) {
                            dispatch(throwErrorMessage({
                                title: "Limite choix dépassée",
                                message: "La question [" + question.question + "] de la section [" + s.title + "] doit présenter au maximum " + question.req_ans + " choix.",
                                dismissAfter: 20000
                            }));

                            multipleChoiceQuestionsOk = false;
                        } else if (!exactQuestionOk) {
                            dispatch(throwErrorMessage({
                                title: "Réponse incompléte",
                                message: "La question [" + question.question + "] de la section [" + s.title + "] doit présenter exactement " + question.req_ans + " choix.",
                                dismissAfter: 20000
                            }));

                            multipleChoiceQuestionsOk = false;
                        }

                    }
                })
        })

        return formOk && allQuestionsOk && multipleChoiceQuestionsOk;
    }
}

export function saveQuestions(form, sections, questions, user) {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });

        dispatch(formsIsLoading(true));
        fetchWithTimeout("/api/v1/human_resources/save_form", {
            method: "POST",
            headers: headers,
            body: JSON.stringify({
                userId: user.id,
                form,
                questions,
            }),
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then(async (surveyResponse) => {
                let transformedSurveyResponse = await adaptResponseForMyOpen(surveyResponse);
                dispatch(setFormSectionsAction(transformedSurveyResponse.survey.pages));
                dispatch(formsIsLoading(false));
            })
            .catch((err) => {
                console.error("Erreur : humanResourcesEditionActions - saveForm", err);

                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de l'enregistrement du formulaire !",
                    })
                );

                dispatch(formsIsLoading(false));
            });
    };
}

export function responseValueChange(sectionId, metaQuestion, sections) {
    return (dispatch) => {
        let copyOfSections = sections.concat();
        let section = copyOfSections.find((b) => b.id === sectionId);

        if (!section) {
            console.error("La section est introuvable");
            return;
        }

        let metaQuestionIndex = section.questions.findIndex((mq) => mq.id === metaQuestion.id);

        if (metaQuestionIndex === undefined || metaQuestionIndex === null) {
            console.error("La réponse est introuvable");
            return;
        }

        section.questions.splice(metaQuestionIndex, 1, metaQuestion);
        dispatch(setFormSectionsAction(copyOfSections));
    };
}

export function setExpandedSection(sectionId) {
    return (dispatch) => {
        dispatch(setCurrentSectionAction(sectionId));
    };
}

export function updateFilters(filters, withRefreshDatas, myInterviews, interviewsToManage, allInterviews, user) {
    return (dispatch) => {
        dispatch(setFormFiltersAction(filters, getFiltersInstance(myInterviews, interviewsToManage, allInterviews)));

        if (!withRefreshDatas) return;

        if (myInterviews) {
            dispatch(getMyFormsAndInterviews(user, filters));
        } else if (interviewsToManage) {
            dispatch(getFormsAndInterviewsToManage(user, filters));
        } else if (allInterviews) {
            dispatch(getInterviewsForHR(user, filters));
        }
    };
}
